import React, { useEffect, useState } from "react";
import { useStore } from "../../context";
import StudentCard from "../../components/StudentCard";
import { urlPensionEstudiantes } from "../../utils";
import { httpGet } from "../../servicios";
import { navigate } from "@reach/router";
import Swal from "sweetalert2";

export default function Pensiones() {
  const { state } = useStore();
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    httpGet(
      urlPensionEstudiantes + sessionStorage.getItem("username"),
      state.token
    )
      .then((res) => {
        if (res.cod === 0) {
          if (res.data.error) {
            setError(true);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Error al recuperar pensiones.",
              confirmButtonColor: "#0d1b3e",
            });
            return;
          }
          if (res.data.length === 0) {
            Swal.fire({
              icon: "info",
              title: "Sin matrículas",
              text: "No hay matrículas para mostrar.",
              confirmButtonColor: "#0d1b3e",
            });
          }
          setRows(res.data);
        } else {
          setError(true);
          setRows([]);
        }
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => setLoading(false));
  }, [state]);

  if (loading) {
    return (
      <div className="modern-spinner fade-in">
        <div className="spinner-ring"></div>
        <span>Cargando estudiantes...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modern-card slide-in-up">
        <div className="modern-alert modern-alert-error">
          <span style={{ fontSize: "1.3rem" }}>⚠️</span>
          <div>
            <strong>Error al cargar datos</strong>
            <br />
            Hubo un error al cargar los datos —{" "}
            <a href="/pensiones/list" className="modern-link">
              Intentar de nuevo
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="slide-in-up">
      {/* Back Navigation */}
      <div style={{ marginBottom: 16 }}>
        <button 
          onClick={() => navigate("/menuMain")} 
          className="btn-modern btn-outline"
          style={{ padding: '10px 20px', display: 'inline-flex', alignItems: 'center', gap: 8, width: 'auto' }}
        >
          ⬅️ Volver al Menú
        </button>
      </div>
      
      <div className="modern-card">
        <div className="modern-card-header">
          <h3>📋 Rubros de Estudiante(s)</h3>
          <span
            className="badge badge-info"
            style={{ fontSize: "0.85rem" }}
          >
            {rows.length} estudiante{rows.length !== 1 ? "s" : ""}
          </span>
        </div>
        <div>
          {rows.map((row) => (
            <StudentCard
              student={row}
              key={row.periodo + row.codNiv + row.codEst}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
